

























import {Component, Prop, Vue} from 'vue-property-decorator';

/**
 * Usage:
 * <jdi-preview>
 *     
 *         <jds-any-component />
 *     <template #code><v-raw-pre>
 *         <jds-any-component />
 *     </v-raw-pre></template>
 * </jdi-preview>
 *
 * Use the v-jdi-code wrapper to convert the slot contents into BOTH the default <slot />, and generate an
 * HTML-escaped version that goes into the <slot name="code" />.
 *
 * See vue.config.js for the regex replacement responsible.
 */
@Component
export default class JdiPreview extends Vue {
    @Prop() code!: string;
    @Prop({default: true, type: Boolean}) showRendered!: boolean;
    @Prop({default: true, type: Boolean}) padded!: boolean;
    @Prop({default: false, type: Boolean}) resizable!: boolean;
    @Prop({default: false, type: Boolean}) canvas!: boolean;

    get out() {
        return '';
    }
}
